import * as React from 'react';

import { Box } from '@uptime/design-system/components/Box';
import { Drawer } from '@uptime/design-system/components/Drawer';

interface Props {
  children: React.ReactNode;
  open: boolean;
  width: number;
  onSidebarClose: () => void;
}

const drawerPaperStyles = {
  boxSizing: 'border-box',
  scrollbarWidth: 'thin',
  borderRadius: 0,
  '&::-webkit-scrollbar': {
    width: '4px',
  },
};

export default function ResponsiveDrawer(props: Props) {
  const { children, open, width, onSidebarClose } = props;

  return (
    <Box component="nav" sx={{ width: { sm: width }, flexShrink: { sm: 0 } }}>
      <Drawer
        variant="temporary"
        open={open}
        onClose={onSidebarClose}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': { ...drawerPaperStyles, width },
        }}
        slotProps={{
          root: {
            keepMounted: true,
          },
        }}
      >
        {children}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', sm: 'block' },
          '& .MuiDrawer-paper': { ...drawerPaperStyles, width },
        }}
        open
      >
        {children}
      </Drawer>
    </Box>
  );
}
